<template>
  <div id="result_wrapper">
    <el-card shadow="never" class="content_box">
      <el-row>
        <el-col :span="24">
          <div class="padding_wrap" v-if="!loading">
            <div class="topBlock">
              <div>
                <StatusIcon :customIcon="iconUrl" />
              </div>
              <div class="title">
                {{ operateAmount | formatNumber(formatDecimalNum) }} {{ currency | currencyConvert }}
              </div>
              <div class="time">{{ time }}</div>
              <div class="desc">{{ resultMessage }}</div>
            </div>
            <div class="detailBlock">
              <el-row type="flex">
                <el-col :span="12" class="detail_label">{{ $t('thirdPartyDeposit.detail.payToAccount') }}</el-col>
                <el-col :span="12" class="detail_content">{{ accountNumber }}</el-col>
              </el-row>
              <el-row v-if="regulatorIncluded" type="flex">
                <el-col :span="12" class="detail_label">{{ $t('thirdPartyDeposit.detail.depositAmount') }}</el-col>
                <el-col :span="12" class="detail_content"
                  >{{ depositAmount | formatNumber(formatDecimalNum) }} {{ currency | currencyConvert }}</el-col
                >
              </el-row>
              <el-row v-if="regulatorIncluded" type="flex">
                <el-col :span="12" class="detail_label">{{ $t('thirdPartyDeposit.detail.depositRebate') }}</el-col>

                <el-col v-if="depositRebate" :span="12" class="detail_content"
                  >{{ depositRebate | formatNumber(formatDecimalNum) }} {{ currency | currencyConvert }}</el-col
                >
                <el-col :span="12" class="detail_content" v-else>--</el-col>
              </el-row>
              <el-row type="flex">
                <el-col :span="12" class="detail_label">{{ $t('thirdPartyDeposit.detail.netDepositAmount') }}</el-col>
                <el-col :span="12" class="detail_content"
                  >{{ netDepositAmount | formatNumber(formatDecimalNum) }} {{ currency | currencyConvert }}</el-col
                >
              </el-row>
              <el-row type="flex" v-if="regulatorIncluded">
                <el-col :span="12" class="detail_label">{{ $t('thirdPartyDeposit.detail.voucherApplied') }}</el-col>
                <el-col :span="12" class="detail_content" v-if="voucherApplied">{{ voucherApplied }}</el-col>
                <el-col :span="12" class="detail_content" v-else>--</el-col>
              </el-row>
              <el-row type="flex" v-if="exchangeRate">
                <el-col :span="12" class="detail_label">{{ $t('thirdPartyDeposit.detail.exchangeRate') }}</el-col>
                <el-col :span="12" class="detail_content"
                  >1 {{ currency | currencyConvert }}≈{{ exchangeRate | formatNumber(2)
                  }}{{ orderCurrency | currencyConvert }}</el-col
                >
              </el-row>
              <el-row type="flex">
                <el-col :span="12" class="detail_label">{{ $t('thirdPartyDeposit.detail.payWith') }}</el-col>
                <el-col :span="12" class="detail_content">{{ paymentChannelName }}</el-col>
              </el-row>
            </div>
            <div class="btn-wrapper" v-if="failure">
              <el-button type="primary" @click="retry" data-testid="retry_button">{{
                $t('thirdPartyDeposit.detail.retry')
              }}</el-button>
            </div>
            <div class="btn-wrapper">
              <el-button
                :type="failure ? 'custom' : 'primary'"
                :class="failure && 'custom_btn'"
                @click="backHome"
                data-testid="back_home_button"
                >{{ $t('thirdPartyDeposit.detail.bkHome') }} {{ `(${backHomeCountDown}s)` }}</el-button
              >
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { apiUpload_card, apiThirdPartyDepositResult } from '@/resource';
import vUpload from '@/components/vUpload';
import StatusIcon from '@/components/StatusIcon.vue';
import SuccessIcon from '@/assets/images/payment/common/success.png';
import failedIcon from '@/assets/images/payment/common/fail.png';
import processingIcon from '@/assets/images/payment/common/processing.png';
import deposit from '@/mixins/deposit';
import { SVG } from '@/constants/regulator';
import sensorsHandler from '@/util/sensorsdata/handler';
import { getDepositStatusByCode } from '@/constants/depositStatusEnum';

export default {
  name: 'ThirdPartyDepositResultPCS',
  data() {
    return {
      loading: true,
      resultMessage: '',
      //第三方入金提示
      successMessage: this.$t('thirdPartyDeposit.result.successMsg'),
      //非第三方入金成功提示
      successMessage2: this.$t('deposit.default.successMsg'),
      instantDepositMessage: this.$t('thirdPartyDeposit.result.message', {
        platform: this.$config.info.fullName
      }),
      rejectMessage: this.$t('thirdPartyDeposit.result.rejectMsg'),
      failureMessage: this.$t('thirdPartyDeposit.result.failureMsg'),
      success: false,
      failure: false,
      info: false,
      fileList: [],
      needUpload: false,
      userId: '',
      paymentDepositId: '',
      excludeResultList: ['localdepositor'],
      operateAmount: 0,
      currency: '',
      orderCurrency: '',
      time: '',
      accountNumber: null,
      depositAmount: null,
      depositRebate: null,
      netDepositAmount: null,
      voucherApplied: null,
      exchangeRate: null,
      payWith: '',
      master: null, //大類
      channel: null, //小類
      isCrypto: false,
      backHomeCountDown: 8,
      backHomeCountDownId: null,
      orderId: null,
      orderStatus: null
    };
  },
  components: { vUpload, StatusIcon },
  computed: {
    defaultException() {
      return this.$t('thirdPartyDeposit.result.defaultException', {
        platform: this.$config.info.fullName,
        email: this.GLOBAL_CONTACT_EMAIL
      });
    },
    iconUrl() {
      if (this.success) {
        return SuccessIcon;
      } else if (this.failure) {
        return failedIcon;
      } else if (this.info) {
        return processingIcon;
      } else {
        return processingIcon;
      }
    },
    formatDecimalNum() {
      return this.isCrypto ? 4 : 2;
    },
    regulatorIncluded() {
      return this.regulator === SVG;
    },
    paymentChannelName() {
      let key1 = `channel.deposit.generalsetting.transactionhistorysubcategory.${this.master}_${this.channel}`;
      let key2 = `channel.deposit.generalsetting.transactionhistorycategory.${this.master}_${this.channel}`;
      if (this.$te(key1)) {
        return this.$t(key1);
      } else if (this.$te(key2)) {
        return this.$t(key2);
      } else {
        return '--';
      }
    }
  },
  methods: {
    updateFileInfo(fileInfo) {
      this.fileList = fileInfo.fileList;
    },
    uploadImg(fileInfo) {
      apiUpload_card({
        paymentDepositId: this.paymentDepositId,
        userId: -1,
        fileList: this.fileList
      })
        .then(resp => {
          if (resp.data.data) {
            this.needUpload = false;
            this.info = true;
            this.resultMessage = this.instantDepositMessage;
          }
        })
        .catch(err => {
          this.$message({
            message: 'Upload failed. please try later.',
            type: 'error'
          });
        });
    },
    getPathName() {
      return window.location.pathname;
    },
    excludeResult(paymentType) {
      return this.excludeResultList.includes(paymentType);
    },
    getPaymentType() {
      let paymentType = this.getPathName().split('/')[1];
      if (paymentType === 'thirdPartyDepositResult') paymentType = this.getPathName().split('/')[2];
      if (paymentType === 'cancel') {
        this.resultMessage = this.failureMessage;
        this.failure = true;
        this.loading = false;
        this.$nextTick(() => {
          this.backHomeCountDowning();
        });
      } else {
        console.log('get result');
        this.getResult(paymentType);
      }
    },
    getResult(paymentType) {
      if (!this.excludeResult(paymentType)) {
        this.postApiThirdPartyDepositResult(paymentType);
      } else {
        this.resultMessage = this.successMessage;
        this.info = true;
        this.loading = false;
        this.$nextTick(() => {
          this.backHomeCountDowning();
        });
      }
    },
    postApiThirdPartyDepositResult(paymentType) {
      apiThirdPartyDepositResult(paymentType, this.$route.query)
        .then(result => {
          const {
            status,
            mt4Account,
            currency,
            orderCurrency,
            operateAmount,
            depositAmount,
            rebateAmount,
            netDepositAmount,
            voucherApplied,
            rate,
            paymentChannel,
            master,
            channel,
            createdTime,
            isCrypto
          } = result.data.data;
          this.operateAmount = operateAmount;
          this.currency = currency;
          this.accountNumber = mt4Account;
          this.depositAmount = depositAmount;
          this.depositRebate = rebateAmount;
          this.netDepositAmount = netDepositAmount;
          this.voucherApplied = voucherApplied;
          this.exchangeRate = rate;
          this.orderCurrency = orderCurrency;
          this.payWith = paymentChannel;
          this.master = master;
          this.channel = channel;
          this.time = createdTime;
          this.isCrypto = isCrypto;
          this.orderStatus = status;
          console.log(status, 'this is status');
          console.log('paymentType > ' + paymentType);
          if (
            paymentType == 'neteller' ||
            paymentType == 'paysafe_neteller' ||
            paymentType.toLowerCase() == 'paytrust' ||
            paymentType == 'paypal'
          ) {
            console.log('neteller or paytrust in');
            this.resultMessage = this.successMessage;
            this.info = true;
            this.loading = false;
          } else if (paymentType == 'skrill' || paymentType == 'paypal') {
            console.log('skrill');
            this.resultMessage = this.successMessage;
            this.info = true;
            this.loading = false;
          } else if (
            paymentType == 'creditcard' ||
            paymentType == 'transact365' ||
            paymentType == 'solid' ||
            paymentType == 'apg' ||
            paymentType == 'sd' ||
            paymentType == 'paypal'
          ) {
            if (result.data.data[0] == '1') {
              if (result.data.data[1] == '1') {
                this.needUpload = true;
                this.userId = result.data.data[2];
                this.paymentDepositId = result.data.data[3];
              } else {
                this.info = true;
                this.resultMessage = this.successMessage;
              }
            } else {
              this.failure = true;
              this.resultMessage = this.failureMessage;
            }
          } else if (paymentType == 'crypto') {
            this.resultMessage = this.successMessage2;
            this.info = true;
          } else if (paymentType == 'cryptousdt' || paymentType == 'paypal') {
            this.resultMessage = this.successMessage;
            this.info = true;
          } else if (paymentType == 'kr_df' || paymentType == 'bitwallet' || paymentType == 'paypal') {
            if (result.data.code == 0) {
              if (result.data.data[0] == '1') {
                this.resultMessage = this.successMessage;
                this.info = true;
              } else {
                this.failure = true;
                this.resultMessage = this.failureMessage;
              }
            } else {
              this.failure = true;
              this.resultMessage = this.failureMessage;
            }
          } else {
            if (result.data.code == 0) {
              if (status == '3') {
                // 支付失败 银行支付失败
                this.resultMessage = this.failureMessage;
                this.failure = true;
              } else if (status == '6') {
                // 手动审核 其他入金审核
                if (paymentType == 'unionpay') {
                  this.resultMessage = this.instantDepositMessage;
                  this.info = true;
                } else if (paymentType == 'cardpay' && result.data.msg == 'upload') {
                  this.paymentDepositId = result.data.extendInteger;
                  this.needUpload = true;
                } else {
                  this.resultMessage = this.defaultException;
                  this.info = true;
                }
              } else if (status == '5') {
                // mt4入金成功
                this.resultMessage = this.successMessage;
                this.success = true;
              } else if (status == '2') {
                //已转账到第三方，但未入金
                this.resultMessage = this.successMessage2;
                this.info = true;
              } else if (status == '7') {
                // 拒绝
                this.resultMessage = this.failureMessage;
                this.failure = true;
              } else {
                this.resultMessage = this.defaultException;
                if (paymentType == 'dollarsmart' || paymentType == 'pagsmile') {
                  this.info = true;
                } else {
                  this.info = true;
                }
              }
            } else {
              console.log(result.data);
              this.resultMessage = this.defaultException;
              this.info = true;
            }
          }

          this.loading = false;
          this.$nextTick(() => {
            this.backHomeCountDowning();
          });
          sensorsHandler('DEPOSIT_RESULTPAGE_VIEW', {
            account_info: this.accountNumber,
            order_id: this.orderId,
            order_status: getDepositStatusByCode(status).description,
            is_success: status == 5 ? 1 : 0,
            deposit_method_number: this.master,
            payment_method_number: this.channel
          });
        })
        .catch(err => {
          this.resultMessage = this.defaultException;
          this.info = true;
          this.loading = false;
        });
    },
    backHomeCountDowning() {
      this.backHomeCountDownId = setInterval(() => {
        this.backHomeCountDown--;
      }, 1000);
    },
    backHome() {
      sensorsHandler('DEPOSIT_BACKTOHOMEPAGE_CLICK', {
        account_info: this.accountNumber,
        deposit_method_number: this.master,
        payment_method_number: this.channel
      });
      this.$router.push('/home');
    },
    retry() {
      console.log(this.orderStatus, getDepositStatusByCode(this.orderStatus).description);
      sensorsHandler('DEPOSIT_RETRY_CLICK', {
        account_info: this.accountNumber,
        order_id: this.orderId,
        deposit_method_number: this.master,
        payment_method_number: this.channel,
        fail_reason: this.orderStatus == 5 ? null : getDepositStatusByCode(this.orderStatus).description
      });
      this.$router.push({ name: 'depositFunds' });
    }
  },
  mounted() {
    this.loading = true;
    if (this.$route.meta.restrictApi) {
      this.resultMessage = this.successMessage;
      this.info = true;
      this.loading = false;
      this.$nextTick(() => {
        this.backHomeCountDowning();
      });
    } else {
      console.log('mounted');
      this.getPaymentType();
    }
  },
  watch: {
    backHomeCountDown(value) {
      if (value === 0) {
        clearInterval(this.backHomeCountDownId);
        this.backHome();
      }
    }
  },
  created() {
    const { order_id, orderNumber, productId, orderId, merchant_order } = this.$route.query;
    this.orderId = order_id || orderNumber || productId || orderId || merchant_order || null;
  }
};
</script>

<style lang="scss" scoped>
#result_wrapper {
  padding-top: 60px;
  @include screen-tablet {
    padding-top: 20px;
  }
  .padding_wrap {
    width: 60%;
    margin: 0 auto;
    max-width: 460px;
    @media (max-width: 767px) {
      width: 100%;
      max-width: unset;
    }
  }
  .topBlock {
    margin-bottom: 20px;
    text-align: center;
    color: $PCS-main-text;
    .title {
      font-size: 26px;
      font-weight: 600;
      margin-top: 15px;
    }
    .time {
      padding: 32px 0;
      font-size: 12px;
      direction: ltr; /* 強制從左到右顯示 */
    }
  }
  .detailBlock {
    border-top: 1px solid rgba($PCS-main-text, 0.12);
    border-bottom: 1px solid rgba($PCS-main-text, 0.12);
    padding: 16px 0 0 0;
    .el-row {
      padding-bottom: 16px;
    }
    .detail_label {
      text-align: left;
      color: rgba($PCS-main-text, 0.65);
      @include rtl-sass-value(text-align, left, right);
    }
    .detail_content {
      text-align: right;
      color: $PCS-main-text;
      font-weight: bold;
      @include rtl-sass-value(text-align, right, left);
    }
  }
  .btn-wrapper {
    margin-top: 35px;
    .el-button {
      width: 100%;
      border-radius: 100px;
      height: 48px;
      &.custom_btn {
        color: rgba($PCS-main-text, 0.45);
        border-color: rgba($PCS-main-text, 0.45);
        &:hover {
          color: rgba($PCS-main-text, 0.6);
          border-color: rgba($PCS-main-text, 0.6);
        }
      }
    }
  }
  .time {
    color: #898787;
  }
}
</style>
